import { isBefore } from "date-fns";

export const getDateBoundary = (selectedDates: [Date | null, Date | null], hoverDate: Date | null) => {
  if (selectedDates[0] && selectedDates[1]) {
    return selectedDates;
  }

  if (selectedDates[0] && hoverDate) {
    if (isBefore(selectedDates[0], hoverDate)) {
      return [selectedDates[0], hoverDate];
    }
    return [hoverDate, selectedDates[0]];
  }

  return [null, null];
};
